module.exports = __webpack_public_path__ + "static/media/home-reporting-background.37559c31.svg";